/**
 * SCH-5.9 — sync-health metrics hooks.
 *
 * Mirrors useSyncHistory's shape (react-query, keyed by its params, modest staleTime). These are
 * aggregates over a bounded summary table, not a live progress feed, so there is nothing to poll.
 */

import { useQuery } from '@tanstack/react-query';

import { syncMetricsService } from '@/services/integrations/syncMetricsService';
import type {
  SyncMetricsBucketSize,
  SyncMetricsRange,
} from '@/types/integrations/syncMetrics';

export function useSyncMetrics(
  range: SyncMetricsRange,
  bucket: SyncMetricsBucketSize,
  options: { enabled?: boolean } = {},
) {
  return useQuery({
    queryKey: ['sch', 'sync-metrics', range, bucket],
    queryFn: () => syncMetricsService.getSyncMetrics(range, bucket),
    staleTime: 60_000,
    enabled: options.enabled ?? true,
  });
}

/** AC4: superadmin-only per-tenant rollup. */
export function useCrossTenantSyncMetrics(
  range: SyncMetricsRange,
  options: { enabled?: boolean } = {},
) {
  return useQuery({
    queryKey: ['sch', 'cross-tenant-sync-metrics', range],
    queryFn: () => syncMetricsService.getCrossTenantSyncMetrics(range),
    staleTime: 60_000,
    enabled: options.enabled ?? true,
  });
}
